export class Code {
    constructor(
         public id: number,
         public code: string,
         public name: string
    ) {}
}
